import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ModalContext } from '../../../../../../modal/ModalContext';
import { ChangeRegimenModal } from './ChangeRegimenModal';

import { fetchWithoutToken } from '../../../../../../../helpers/fetch';
import Swal from 'sweetalert2';

export const TaxpayerInformation = React.memo(({ regimeSatCode, taxpayer, year, month, isOld }) => {
  const { handleModal } = useContext(ModalContext);

  const [regime, setRegime] = useState(null);
  const [activities, setActivity] = useState([]);
  const [idAct, setIdAct] = useState(null);
  const [ciecMessage, setCiecMessage] = useState(taxpayer.mensajeCiec || 'CIEC Sin Validar');
  const [isValidating, setIsValidating] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(taxpayer).length !== 0) {
      const regime = taxpayer.regimes.find((e) => e.satCode === regimeSatCode);

      setActivity(taxpayer.profileRegimes);
      setRegime(regime);
      setCiecMessage(taxpayer.mensajeCiec || 'CIEC Sin Validar');
    }
  }, [regimeSatCode, taxpayer]);

  const handleValidateCiec = async () => {
    if (isValidating) return;

    Swal.fire({
      title: 'Validando CIEC',
      text: 'Por favor espere...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    setIsValidating(true);
    try {
      const resp = await fetchWithoutToken(`api/DownloadXmlSAT/ValidateCiecMessage/${taxpayer.id}/false`, null, 'POST');
      const body = await resp.json();

      const success = body.success !== undefined ? body.success : body.Success;
      const message = body.error || body.Error || body.data || body.Data;

      if (success) {
        const finalMessage = message || 'CIEC Válida';
        setCiecMessage(finalMessage);
        Swal.fire({
          icon: 'success',
          title: 'Validación completada',
          text: finalMessage,
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al validar',
          text: message || 'Ocurrió un error inesperado',
        });
      }
    } catch (error) {
      console.error('Error validating CIEC:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error de red',
        text: 'No se pudo conectar con el servidor',
      });
    } finally {
      setIsValidating(false);
    }
  };

  if (isOld) {
    return (
      <div className='col-md-12'>
        <strong>Datos del contribuyente</strong> <br />
        <strong>Nombre contribuyente:</strong> {taxpayer.businessName} <br />
        <strong>RFC contribuyente:</strong> {taxpayer.rfc} <br />
        {regime && (
          <Fragment>
            <strong>Regimen:</strong> {regime.satCode} - {regime.officialName} <br />
          </Fragment>
        )}
        {
          <Fragment>
            <strong>
              Actividad(es):{' '}
              {activities.map((actividad) => (
                <span key={actividad.id}>
                  {actividad.activities.map((activity, index) => (
                    <span
                      className='d-flex row justify-content-start pl-3'
                      key={index}>
                      <span style={{ fontWeight: 'normal' }}>{activity.id} - </span>
                      <span style={{ fontWeight: 'normal' }}> {activity.description}</span>
                      {index < actividad.activities.length - 1 ? <span style={{ fontWeight: 'normal' }}>, </span> : null}
                    </span>
                  ))}
                </span>
              ))}
            </strong>
          </Fragment>
        }
        <Fragment>
          <strong>Estado CIEC: </strong>
          {ciecMessage && (
            <button
              className={`badge ` + (ciecMessage.includes('CIEC Válida') ? 'badge-success' : ciecMessage.includes('CIEC Sin Validar') ? 'badge-warning' : 'badge-danger')}
              style={{ fontSize: '1em', padding: '0.5em 1em', border: 'none', cursor: 'pointer' }}
              onClick={handleValidateCiec}
              disabled={isValidating}>
              {ciecMessage}
            </button>
          )}
          <br />
          <button
            className='btn btn-sm btn-primary float-right ml-3'
            onClick={() =>
              handleModal(
                <ChangeRegimenModal
                  taxpayer={taxpayer}
                  year={year}
                  month={month}
                />,
              )
            }>
            Cambiar regimenes
          </button>
        </Fragment>
            
      </div>
    );
  }
  return (
    <div className='table-responsive'>
      <table
        className='table table-bordered table-sm mb-0'
        style={{ tableLayout: 'auto', whiteSpace: 'nowrap' }}>
        <thead className='thead-light'>
          <tr>
            <th
              className='align-middle text-center'
              colSpan={2}>
              Datos del contribuyentes
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className='font-weight-bold'>Nombre contribuyente</td>
            <td>{taxpayer.businessName}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>RFC contribuyente</td>
            <td>{taxpayer.rfc}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>Estado CIEC</td>
            <td>
              {ciecMessage && (
                <button
                  className={`badge ` + (ciecMessage.includes('CIEC Válida') ? 'badge-success' : ciecMessage.includes('CIEC Sin Validar') ? 'badge-warning' : 'badge-danger')}
                  style={{ fontSize: '1em', padding: '0.5em 1em', border: 'none', cursor: 'pointer' }}
                  onClick={handleValidateCiec}
                  disabled={isValidating}>
                  {ciecMessage}
                </button>
              )}
            </td>
          </tr>
          {regime && (
            <tr>
              <td className='font-weight-bold'>Régimen</td>
              <td>
                {regime.satCode} - {regime.officialName}
              </td>
            </tr>
          )}
          <tr>
            <td className='font-weight-bold'>Actividad(es)</td>
            <td>
              {activities.map((actividad) => (
                <span key={actividad.id}>
                  {actividad.activities.map((activity, index) => (
                    <span key={index}>
                      {activity.id} - {activity.description}
                      {index < actividad.activities.length - 1 ? ', ' : ''}
                    </span>
                  ))}
                  <br />
                </span>
              ))}
            </td>
          </tr>
          <tr>
            <td
              colSpan={2}
              className='text-right'>
              <button
                className='btn btn-sm btn-primary'
                onClick={() =>
                  handleModal(
                    <ChangeRegimenModal
                      taxpayer={taxpayer}
                      year={year}
                      month={month}
                    />,
                  )
                }>
                Cambiar regimenes
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});
